import { AxiosError } from 'axios';
import { format } from 'date-fns';
import { useEffect, useState } from 'react';
import { useQuery } from 'react-query';

import { useAppDispatch, useAppSelector } from './useReduxHooks';
import { getForeignCurrencyHistory } from '@/api/fx';
import { GetForeignCurrencyHistoryResponse } from '@/types/fx.type';
import {
  setSize as setFxSize,
  setStatus as setFxStatus,
} from '@/store/modules/fxReceipt';

export const useGetForeignCurrencyHistory = () => {
  const dispatch = useAppDispatch();
  const { size, status, filter } = useAppSelector((state) => state.fxReceipt);
  const [totalPage, setTotalPage] = useState(0);
  const [enabled, setEnabled] = useState(false);
  const [pageNumber, setPageNumber] = useState(0);

  const params = {
    page: pageNumber,
    size,
    startDate: format(filter.startDate, 'yyyy-MM-dd'),
    endDate: format(filter.endDate, 'yyyy-MM-dd'),
    status,
  };

  useEffect(() => {
    setEnabled(true);
    return () => setEnabled(false);
  }, [filter]);

  useEffect(() => {
    setPageNumber(0);
  }, [size]);

  const { data, refetch, isLoading } = useQuery<
    GetForeignCurrencyHistoryResponse,
    AxiosError
  >(
    ['foreignCurrencyHistory', params],
    () => getForeignCurrencyHistory(params),
    {
      onSuccess: (res) => {
        console.log(res);
        setTotalPage(res.foreignCurrencies.totalPages);
      },
      retry: false,
      enabled,
    },
  );

  const foreignCurrencies = data?.foreignCurrencies;
  const summary = data?.summary;

  // Redux action을 래핑한 함수들
  const setSize = (newSize: number) => dispatch(setFxSize(newSize));
  const setSizeAndResetPage = (newSize: number) => {
    dispatch(setFxSize(newSize));
  };
  const setStatus = (newStatus: 'ALL' | 'SAVED' | 'CANCELED') =>
    dispatch(setFxStatus(newStatus));

  return {
    foreignCurrencies,
    summary,
    totalPage,
    refetch,
    pageNumber,
    setPageNumber,
    size,
    setSize,
    setSizeAndResetPage,
    isLoading,
    status,
    setStatus,
  };
};
